import { MagnifyingGlassIcon as MagnifyingGlassIconSolid } from "@heroicons/react/16/solid";
import { useStore } from "@nanostores/react";
import { ReactElement, useState } from "react";

import { $cytoscapeInstance } from "../../stores/graph/ui.ts";
import { Input } from "../catalyst/Input.tsx";
import { FloatingTool } from "./FloatingTool.tsx";

export const FloatingSearch = (): ReactElement => {
  const [searchTerm, setSearchTerm] = useState("");
  const cytoscapeInstance = useStore($cytoscapeInstance);

  const handleGraphSearch = (e: React.FormEvent): void => {
    e.preventDefault();
    if (!cytoscapeInstance || !searchTerm) return;

    // Clear previous selection
    cytoscapeInstance.elements().unselect();

    // Search through all nodes
    cytoscapeInstance
      .nodes()
      .filter((node) => {
        const nodeData = node.data();
        // Search in all node data fields
        return Object.values(nodeData).some((value) =>
          String(value).toLowerCase().includes(searchTerm.toLowerCase()),
        );
      })
      .select();

    // Fit view to selection if there are matches
    if (cytoscapeInstance.nodes(":selected").length > 0) {
      cytoscapeInstance.fit(cytoscapeInstance.nodes(":selected"));
    }

    // Clear search term after search
    setSearchTerm("");
  };

  const searchIcon = (
    <MagnifyingGlassIconSolid className="h-6 w-6 text-zinc-400 hover:text-zinc-200" />
  );

  const searchContent = (
    <div className="ring-.75 min-w-[280px] rounded-lg bg-zinc-900/90 p-3 shadow-lg ring-zinc-600">
      <form className="flex items-center" onSubmit={handleGraphSearch}>
        <Input
          autoFocus
          className="w-full border-zinc-600 bg-zinc-800/50 text-zinc-200 placeholder-zinc-400"
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search nodes..."
          type="search"
          value={searchTerm}
        />
      </form>
    </div>
  );

  return <FloatingTool icon={searchIcon}>{searchContent}</FloatingTool>;
};
